import script from "./WizardNav.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardNav.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import WizardButton from "@/components/neue/wizard/WizardButton.vue";
script.components = Object.assign({}, { WizardButton }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { WizardButton }, script.__o.components);}